import React, { useMemo } from 'react';

import SmartLink from '../../components/Library/SmartLink';
import CenterLoadingSpinner from '../../components/LoadingSpinner/CenterLoadingSpinner';
import Panel from '../../components/Panel';
import { useAccountContext } from '../../contexts/AccountContext';
import { getIconForService } from '../../libs/libIcon';
import useTitle from '../../libs/useTitle';
import { sortBy } from '../../libs/utils';

const Apps: React.FC = () => {
  const accountContext = useAccountContext();

  const apps = useMemo(() => {
    return accountContext.currentAccountEntitlementComponents.filter((a) => !a.urlRequired || (a.urlRequired && a.url != null)).sort(sortBy('label'));
  }, [accountContext.currentAccountEntitlementComponents]);

  useTitle('Apps');

  return <>
    <div className=''>
      <div className='max-w-[100vw] px-12 xl:px-0 3xl:max-w-screen-2xl 2xl:max-w-screen-xl xl:max-w-screen-lg mx-auto'>
        <div>
          <h2 className='text-2xl my-8'>My Apps</h2>
        </div>
        <div className='flex flex-wrap w-full'>
          {apps.map((tool) => {
            return (
              <div key={tool.label} className='w-full md:w-1/4 p-2'>
                <SmartLink to={tool.url} target={'_blank'} targetExternal={true}>
                  <Panel>
                    <div className='w-full flex flex-col py-6'>
                      <div className='p-1 mx-auto'>
                        {getIconForService(tool.label, 'text-[7rem]', 'h-28 w-28')}
                      </div>
                      <div className='pt-2 mx-auto text-lg'>
                        {tool.label}
                      </div>
                    </div>
                  </Panel>
                </SmartLink>
              </div>
            );
          })}
          {accountContext.currentAccount == null && <>
            <CenterLoadingSpinner />
          </>}
        </div>
      </div>
    </div>
  </>;
};

export default Apps;
